export default __webpack_public_path__ + "static/media/32E4A31C-75C6-49AC-AF74-F3420F108E06_1_105_c.0d5bf29f.jpeg";